var version = {
    "name":      "dativery",
    "buildDateCode": "20260602-153026",
    "buildDate": "Tue Jun 02 2026 15:30:26 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260602-153026",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;